import { AbrProvider } from '@sky-uk-ott/vpt-abr';
import { sdkLogger } from '../../../logger';
import { ShakaToAbrWrapper } from './shaka-to-abr-wrapper';
import { applyAbrStreamTypeOverrides, getAbrProviderConfig } from '../../../propositions/abr/abr-config-helpers';
import { SimpleAbrManager } from './simple-abr-manager/simple-abr-manager';
export var getShakaAbrFactory = function(shakaInstance, playbackType, abrShakaConfig) {
    var simpleAbrManager = function() {
        return new SimpleAbrManager();
    };
    if (!abrShakaConfig) {
        sdkLogger.info('Using custom CVSDK SimpleAbrManger');
        return simpleAbrManager;
    }
    var config = getAbrProviderConfig(sdkLogger, abrShakaConfig.providerConfig);
    var abrProvider = new AbrProvider(config);
    var shakaConfig = shakaInstance.getConfiguration();
    var playerConfig = {
        bufferCapacity: shakaConfig.streaming.bufferingGoal
    };
    var playbackTypeSpecificConfig = applyAbrStreamTypeOverrides(playbackType, abrShakaConfig.abrConfig);
    if (!playbackTypeSpecificConfig) {
        sdkLogger.info('Using custom CVSDK SimpleAbrManger');
        return simpleAbrManager;
    }
    var abrManager = abrProvider.getAbrManager(playerConfig, playbackTypeSpecificConfig);
    if (!abrManager) {
        sdkLogger.info('Using custom CVSDK SimpleAbrManger');
        return simpleAbrManager;
    }
    var destroy = function() {
        return abrProvider.destroy();
    };
    return function() {
        return new ShakaToAbrWrapper(abrManager, shakaInstance, destroy, playbackTypeSpecificConfig.playerSpecificConfig);
    };
};

//# sourceMappingURL=shaka-abr-factory.js.map